import { ComponentStyleConfig } from '@chakra-ui/react'

export const Text: ComponentStyleConfig = {
  sizes: {
    xxl: {
      fontFamily: 'Satoshi',
      fontSize: '32px',
      lineHeight: '40px',
    },
    xl: {
      fontFamily: 'Satoshi',
      fontSize: '24px',
      lineHeight: '36px',
    },
    lg: {
      fontFamily: 'Satoshi',
      fontSize: '18px',
      lineHeight: '28px',
    },
    md: {
      fontFamily: 'Satoshi',
      fontSize: '16px',
      lineHeight: '24px',
    },
    sm: {
      fontFamily: 'Satoshi',
      fontSize: '14px',
      lineHeight: '22px',
    },
    xs: {
      fontFamily: 'Satoshi',
      fontSize: '12px',
      lineHeight: '18px',
    },
    xxs: {
      fontFamily: 'Satoshi',
      fontSize: '10px',
      lineHeight: '16px',
    },
  },
}
